/**
 * VERSIONE LIBRERIA 3
 */

function Log(enabled) {
	this.enable = function () {
		Log.prototype.info = console.info.bind(window.console);
		Log.prototype.debug = console.debug.bind(window.console);
		Log.prototype.warn = console.warn.bind(window.console);
		Log.prototype.error = console.error.bind(window.console);
	}
	this.disable = function () {
		Log.prototype.info = function () {};
		Log.prototype.debug = function () {};
		Log.prototype.warn = function () {};
		Log.prototype.error = function () {};
	}

	if (enabled) {
		this.enable();
	} else {
		this.disable();
	}
}
var log = new Log(true);






// function Log(enabled) {
// 	var self = this;
// 	this.INFOLEVEL = 3;
// 	this.DEBUGLEVEL = 2;
// 	this.WARNLEVEL = 1;
// 	this.ERRORLEVEL = 0;
// 	this._logLevel = this.INFOLEVEL;
// 	this._logging = enabled;
// 	this._lines = new Array();
// 	this.maxline = 100;
// 	this._INFOBGCOLOR = "#F0FFFF";
// 	this._DEBUGBGCOLOR = "#FFFFFF";
// 	this._WARNBGCOLOR = "#FFFFE0";
// 	this._ERRORBGCOLOR = "#FFE4E1";
// 	this._wpopup = null;
//
// 	this.disable = function () {
// 		this._logging = 0;
// 	}
//
// 	this.enable = function() {
// 		this._logging = 1;
// 	}
//
// 	this.setLogLevel = function (level) {
// 		this._logLevel = level;
// 	}
//
// 	this.info = function (msg) {
// 		if (!self._logging || self._logLevel < self.INFOLEVEL ) return;
// 		if (console && console.info) {
// 			var callerName = arguments.callee.caller?arguments.callee.caller.name:"main";
// 			console.log(arguments);
// 			//arguments = arguments? arguments.unshift(callerName):[callerName];
// 			//arguments.unshift(callerName);
// 			console.info.apply(console,arguments);
// 		};
// 	}
//
// 	this.warn = function (msg) {
// 		var callerName = arguments.callee.caller?arguments.callee.caller.name:"main";
// 		if (!self._logging || self._logLevel < self.WARNLEVEL) return;
// 		if (console && console.warn) {
// 			console.warn.apply(console,arguments);
// 			/*
// 			//console.warn(callerName,msg);
// 			if (Array.isArray(arguments))
// 				console.warn.apply(null,arguments);
// 			else
// 				console.warn(callerName,msg);
// 				*/
// 		}
// 		self._write(self._WARNBGCOLOR , msg);
// 	}
//
// 	this.error = function (msg) {
// 		var callerName = arguments.callee.caller?arguments.callee.caller.name:"main";
// 		if (!self._logging ) return;
// 		if (console && console.error) {
// 			console.error.apply(console,arguments);
// 			/*
// 			//console.error(callerName,msg);
// 			if (Array.isArray(arguments))
// 				console.error.apply(null,arguments);
// 			else
// 				console.error(callerName,msg);
// 				*/
// 		}
// 		self._write(self._ERRORBGCOLOR , msg);
// 	}
//
// 	this.debug = function (msg) {
// 		var callerName = arguments.callee.caller?arguments.callee.caller.name:"main";
// 		if (!self._logging || self._logLevel < self.DEBUGLEVEL) return;
// 		//console.log(arguments,Array.isArray(arguments),typeof arguments);
// 		if (console && console.debug) {
// 			console.debug.apply(console,arguments);
// 			//console.debug(callerName,msg);
// 			/*
// 			if (Array.isArray(arguments))
// 				console.debug.apply(null,arguments);
// 			else
// 				console.debug(callerName,msg);
// 				*/
// 		}
// 		self._write(self._DEBUGBGCOLOR , msg);
// 	}
//
// 	this._write = function (bgcolor,msg) {
// 		if (self._lines.length == 100)
// 			self._lines.splice(0, 1);
// 		self._lines.push({bgcolor:bgcolor,msg:msg});
// 		//var str = "<div style='background-color:"+bgcolor+"'>"+msg+"</div>";
// 		//self._lines.push(str);
// 	}
//
// 	this.show = function () {
// 		if (!self._wpopup)
// 			self._wpopup = window.open();
// 		var lines = self._lines.join("\n");
// 		self._wpopup.document.write(lines);
// 	};
// 	this.showB = function (modal_id) {
// 		var lines = self._lines.join("\n");
// 		$('#'+modal_id + " .modal-body").html("");
// 		for (var i in self._lines) {
// 			var line = self._lines[i];
// 			var msg = "";
// 			if (line.msg instanceof String)
// 				msg = line.msg;
// 			else
// 				msg = JSON.stringify(line.msg);
// 			$('#'+modal_id + " .modal-body").append("<div style='background-color:"+line.bgcolor+"'>");
// 			$('#'+modal_id + " .modal-body").append(i+")"+msg);
// 			$('#'+modal_id + " .modal-body").append("</div>");
// 		}
// 		//$('#'+modal_id + " .modal-body").html(lines);
// 		$('#'+modal_id).modal("show");
// 	}
// }

//var log = new Log(1);